import range from 'lodash/range';
import { defineComponent, ref, computed } from 'vue-demi';
import { p as pxToRem } from './px-to-rem-0b26b83e.js';
import { d as SkeletonTextContainerRoot, S as SkeletonRoot, e as SkeletonText, b as SkeletonAnimated } from './styles-ed564e39.js';
import { openBlock, createElementBlock, normalizeClass, normalizeStyle, Fragment, renderList } from 'vue';

var script = defineComponent({
  name: 'OrSkeletonText',
  props: {
    animated: {
      type: Boolean,
      required: false,
      default: true
    },
    linesCount: {
      type: Number,
      required: false,
      default: 1
    },
    width: {
      type: [Number, String],
      required: false,
      default: '100%'
    },
    fontSize: {
      type: Number,
      required: false,
      default: 16
    },
    lineHeight: {
      type: Number,
      required: false,
      default: 24
    }
  },
  expose: ['root'],
  setup(props) {
    // Refs
    const root = ref();
    // Styles
    const containerStyles = computed(() => ['or-skeleton-text-root', ...SkeletonTextContainerRoot]);
    const containerStyle = computed(() => {
      var _a;
      const width = (_a = props.width) !== null && _a !== void 0 ? _a : '100%';
      return {
        'width': typeof width === 'number' ? pxToRem(width) : width
      };
    });
    const rowStyles = computed(() => ['or-skeleton-v3', 'or-skeleton-text', ...SkeletonRoot, ...SkeletonText, ...(props.animated ? SkeletonAnimated : [])]);
    const rowStyle = computed(() => {
      var _a, _b;
      const height = (_a = props.fontSize) !== null && _a !== void 0 ? _a : 16;
      const margin = (((_b = props.lineHeight) !== null && _b !== void 0 ? _b : 24) - height) / 2;
      return {
        'height': typeof height === 'number' ? pxToRem(height) : height,
        'margin': `${typeof margin === 'number' ? pxToRem(margin) : margin} 0`
      };
    });
    // State
    const lineKeys = computed(() => range(props.linesCount));
    return {
      root,
      containerStyles,
      containerStyle,
      rowStyles,
      rowStyle,
      lineKeys
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.containerStyles),
    style: normalizeStyle(_ctx.containerStyle)
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.lineKeys, key => {
    return openBlock(), createElementBlock("div", {
      key: key,
      class: normalizeClass(_ctx.rowStyles),
      style: normalizeStyle(_ctx.rowStyle)
    }, null, 6 /* CLASS, STYLE */);
  }), 128 /* KEYED_FRAGMENT */))], 6 /* CLASS, STYLE */);
}

script.render = render;
script.__file = "src/components/or-skeleton-v3/or-skeleton-text-v3/OrSkeletonText.vue";

export { script as s };
